import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bingo from 'modules/Bingo';
import RadioGroup from 'components/RadioGroup';
import './ticketSelect.css';

const presets = {
  [Bingo.constants.GAME_TYPE['30']]: ['4', '12', '40'],
  [Bingo.constants.GAME_TYPE['75']]: ['6', '18', '60'],
  [Bingo.constants.GAME_TYPE['90']]: ['6', '18', '60']
};

class TicketMultiSelect extends Component {
  setNoTixRef = (_) => {
    this.noTix = _;
  };

  handleChange = (event, { value }) => {
    this.props.handleClick(parseInt(value, 10));
  };

  render() {
    const { max, loading, selection, type } = this.props;

    return (
      <div className="ticketSelect">
        <h4>{loading ? 'Loading tickets...' : max > 0 ? 'Auto Select' : 'No tickets left'}</h4>
        <RadioGroup
          values={presets[type]}
          uid="default"
          max={max}
          custom={max > 0}
          onChange={this.handleChange}
          value={selection.toString()}
          disabled={loading}
        />
      </div>
    );
  }
}

TicketMultiSelect.propTypes = {
  type: PropTypes.oneOf(['30', '75', '90']).isRequired,
  max: PropTypes.number,
  loading: PropTypes.bool,
  selection: PropTypes.number.isRequired
};

TicketMultiSelect.defaultProps = {
  max: 1,
  loading: false
};

export default TicketMultiSelect;
